import i18n from '@/i18n'

const mapperHeadlightToSelect = headlight => {
    const { id, hex, title } = headlight
    return {
        id,
        title: i18n.t(`headlight.${title}`),
        color: {
            hex,
            title: i18n.t(`headlight.${title}`),
        },
    }
}

export { mapperHeadlightToSelect }
